{
  "buttonLabel": "عرض المقترحات",
  "countAnnouncement": "{optionCount, plural, one {# خيار} other {# خيارات}} متاحة.",
  "focusAnnouncement": "{isGroupChange, select, true {المجموعة المدخلة {groupTitle}, مع {groupCount, plural, one {# خيار} other {# خيارات}}. } other {}}{optionText}{isSelected, select, true {, محدد} other {}}",
  "listboxLabel": "مقترحات",
  "selectedAnnouncement": "{optionText}، محدد"
}
